<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.phaseReworks'), $t('text.list')]">
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.keyword"
            :placeholder="$t('workOrder.serialNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('placeholder.productNoCustomerProductNo')"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        :loading="loading"
        id="recordsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images" />
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          width="85"
        >
          <template v-slot="{ row }">
            <small v-if="row.workOrder && row.workOrder.hurry" class="red"
              >({{ $t("order.hurrySimple") }})
            </small>
            {{ row.serialNo }}
            <div
              v-if="row.workOrder && row.workOrder.pauseAt != null"
              class="orange font10"
            >
              ({{ $t("text.stop") }})
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="workOrder.factoryName"
          :title="$t('menu.factories')"
          min-width="100"
        />

        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.workOrder &&
                row.workOrder.orderCustomerProductNo != null &&
                row.workOrder.orderCustomerProductNo.trim() != ''
              "
              >({{ row.workOrder.orderCustomerProductNo }})</small
            >
            <div v-if="row.workOrder" class="font10">
              {{ row.workOrder.category }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.quantity
            }}<span v-if="row.workOrder">{{ row.workOrder.unit }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="source"
          :title="$t('customer.source')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ $t("reworkTypes." + row.source) }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="type"
          :title="$t('text.type')"
          min-width="100"
        />

        <vxe-table-column
          field="remark"
          :title="$t('rework.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.reason" :number="6" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="voucher"
          :title="$t('payment.voucher')"
          min-width="90px"
        >
          <template v-slot="{ row }">
            <thumbnail-text :srcs="row.voucher" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="phaseName"
          :title="$t('menu.phases')"
          min-width="100"
        />
        <vxe-table-column
          field="workerName"
          :title="$t('menu.workers')"
          min-width="100"
        />
        <vxe-table-column
          field="createdAt"
          :title="$t('text.createAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <div>{{ row.createAt }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="finishAt"
          :title="$t('hang.finishAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <div>{{ row.finishAt }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          v-if="Permit.canActionsChargeEdition('mesReworkFinish')"
          field="action"
          :title="$t('text.action')"
          min-width="50"
        >
          <template v-slot="{ row }">
            <el-button
              v-if="row.finishAt == null"
              type="text"
              size="mini"
              @click="finish(row)"
              >{{ $t("action.finish") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <el-dialog
      :title="$t('action.finish')"
      :close-on-click-modal="false"
      :visible.sync="finishDF"
      width="30%"
    >
      <el-form ref="finishForm" :model="finishObj">
        <el-form-item
          :prop="'workerId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('menu.workers')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="finishObj.workerId"
            :placeholder="$t('menu.workers')"
            filterable
          >
            <el-option
              v-for="worker in workers"
              :key="worker.id"
              :label="worker.nameSerialNo"
              :value="worker.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="finishSubmitDoing"
          size="small"
          @click="finishSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="finishDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import ThumbnailText from "@/components/ThumbnailText";
import Rework from "@/api/rework.js";
import Factory from "@/api/factory.js";
import UserFactory from "@/api/userFactory.js";
import Worker from "@/api/worker.js";
import ReworkType from "@/api/reworkType.js";

export default {
  mixins: [
    page,
    table.pager,
    table.search,
    table.narrow,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    ThumbnailText,
  },
  data() {
    return {
      narrows: [
        [
          {
            label: this.$t("rework.reworkInfo"),
            items: [
              {
                label: this.$t("reworkInfos.yes"),
                key: "yes",
                condition: { finish: "yes" },
              },
              {
                label: this.$t("reworkInfos.no"),
                key: "no",
                condition: { finish: "no" },
              },
            ],
          },
          {
            label: this.$t("customer.source"),
            items: Rework.types_phase.map((t) => {
              return {
                label: this.$t("reworkTypes." + t),
                key: t,
                condition: { source: t },
              };
            }),
          },
        ],
      ],
      initFilter: "no",
      searchForm: {
        keyword: null,
        productNo: null,
      },
      sorter: {
        sortBy: "reworks_id",
        sortIndicator: "desc",
      },
      factories: [],
      userFactories: [],
      mesAuthFactories: [],
      // 返工完成
      row: null,
      workers: [],
      finishDF: false,
      finishObj: {
        workerId: null,
        workerName: null,
      },
      finishSubmitDoing: false,
    };
  },

  created() {
    const self = this;
    axios
      .all([
        Factory.findByTenantId(),
        UserFactory.findByUserId(self.Permit.currentUser().id),
        ReworkType.findByTenantId(),
      ])
      .then(
        axios.spread(function (factories, userFactory, reworkTypes) {
          if (factories.status === 200) {
            self.factories = factories.data;
          } else {
            self.sysError();
          }
          if (userFactory.status == 200) {
            self.userFactories = userFactory.data;

            if (self.Permit.currentUser().admin === true) {
              self.mesAuthFactories = self.factories;
            } else {
              const userFactoryIds = self.userFactories.map((u) => u.factoryId);
              self.mesAuthFactories = self.factories.filter((f) =>
                userFactoryIds.includes(f.id)
              );
            }
            self.narrowsFactories();
          } else {
            self.sysError();
          }
          if (reworkTypes.status == 200) {
            self.narrows.push([
              {
                label: self.$t("text.type"),
                items: reworkTypes.data.map((reworkType) => {
                  return {
                    label: reworkType.name,
                    key: reworkType.id,
                    condition: { typeId: reworkType.id },
                  };
                }),
              },
            ]);
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    //
    finish(row) {
      const self = this;
      if (row.workerId !== null) {
        if (confirm(self.$t("prompt.confirmFinish"))) {
          const data = {
            workerId: row.workerId,
            workerName: row.workerName,
          };
          Rework.finish(row.id, data).then(function (res) {
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.finishSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        }
      } else {
        self.row = row;
        Worker.findByPhaseId(row.phaseId).then(function (res) {
          if (res.status === 200) {
            self.workers = res.data;
            if (self.workers.length !== 0) {
              for (const worker of self.workers) {
                Vue.set(
                  worker,
                  "nameSerialNo",
                  worker.name + "(" + worker.serialNo + ")"
                );
              }
            }
            if (self.workers.length == 1) {
              self.finishObj.workerId = self.workers[0].id;
            }
          } else {
            self.sysError();
          }
        });
        self.finishDF = true;
      }
    },
    finishSubmit() {
      const self = this;
      self.$refs.finishForm.validate((valid) => {
        if (valid) {
          self.finishObj.workerName = self.workers.find(
            (w) => w.id === self.finishObj.workerId
          ).name;
          self.finishSubmitDoing = true;
          Rework.finish(self.row.id, self.finishObj).then(function (res) {
            self.finishSubmitDoing = false;
            self.finishDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.finishSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    narrowsFactories() {
      if (this.mesAuthFactories.length != 0) {
        this.narrows.push([
          {
            label: this.$t("menu.factories"),
            items: this.mesAuthFactories.map((factory) => {
              return {
                label: factory.name,
                key: factory.id,
                condition: { factoryId: factory.id },
              };
            }),
          },
        ]);
      }
    },

    dataProvider(params) {
      return Rework.searchMes(params);
    },
  },
};
</script>
